'use es6'; // @ts-expect-error module is untyped

import localeComparator from 'I18n/utils/localeComparator';
import { createSelector } from 'reselect';

const getSearchTagsData = state => state.storefront.searchTags.data;

export const getSearchTagsRequestState = state => state.storefront.searchTags.requestState;
export const getSearchTagsOptions = createSelector([getSearchTagsData], searchTags => searchTags.toArray().map(value => ({
  text: value,
  value
})).sort((a, b) => localeComparator(a.text, b.text)));
export const getUnusedFiltersData = state => state.storefront.unusedFilters.data;
export const getUnusedFiltersRequestState = state => state.storefront.unusedFilters.requestState;